import {
  resultsetWithFields,
  printNoDataChart,
  printDataChart,
  initChart,
  MONTHS_YEAR_SHORT,
  addPointInteger,
  capitalizarTexto
} from 'vlcishared';
import { OPTIONS_INTERVENCIONES_STACKED as options } from './options-charts';
import { TEXTS_SEGURIDAD } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { COLORS_GENDER } from '../colors';

export function echartIntervencionesTotalesStacked(
  vis,
  datos,
  idChart,
  idNoData,
) {
  const chartOptions = JSON.parse(JSON.stringify(options));
  chartOptions.yAxis[0].axisLabel.formatter =
    options.yAxis[0].axisLabel.formatter;
  chartOptions.tooltip.formatter = function (param) {
    let tooltipContent = `${param[0].name}</br>`;
    tooltipContent += param
      .map(function (param) {
        const value = param.value;
        return `<div style="display: inline-flex; justify-content: space-between; gap: 20px; width: 100%">
                <span>${
                  param.marker
                } ${capitalizarTexto(param.seriesName)}</span>
                <span>${addPointInteger(Math.round(value))}</span>
              </div>`;
      })
      .join('<br />');
    return tooltipContent;
  };

  if (datos.resultset.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);

    let seriesMap = {};
    const groupedData = {};

    const resultSet = resultsetWithFields(datos);

    // Agrupar los datos por hora/dia
    resultSet.forEach((row) => {
      let tiempo;
      if (idChart == 'chart_IntervencionesHoras') {
        tiempo = row.tiempo + ':00';
      } else {
        tiempo = row.tiempo;
      }
      if (!groupedData[tiempo]) {
        groupedData[tiempo] = {};
        chartOptions.xAxis[0].data.push(tiempo);
      }

      groupedData[tiempo][row.category] = row.count;

      groupedData[tiempo][row.category] = row.count;

      if (!chartOptions.legend.data.includes(row.category)) {
        chartOptions.legend.data.push(row.category);
        seriesMap[row.category] = {
          name: row.category,
          type: 'bar',
          stack: 'total',
          data: [],
        };
      }
    });

    chartOptions.xAxis[0].data.forEach((time) => {
      chartOptions.legend.data.forEach((cat) => {
        seriesMap[cat].data.push(groupedData[time][cat] || 0);
      });
    });

    chartOptions.series = Object.values(seriesMap);
    if (idChart == 'chart_IntervencionesHoras') {
      chartOptions.title.subtext =
        TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('evolucion_horaria');
      chartOptions.grid.bottom = '55';
      chartOptions.media = [
        {
          //barWidth peq
          query: {
            maxWidth: 484,
          },
          option: {
            series: {
              barWidth: 10,
            },
          },
        },
        {
          //barWidth big
          query: {
            minWidth: 485,
          },
          option: {
            series: {
              barWidth: 16,
            },
          },
        },
        {
          // titles maxHeight: 240
          query: {
            maxHeight: 240,
          },
          option: {
            title: {
              itemGap: 3,
              textStyle: {
                fontSize: 13,
              },
              subtextStyle: {
                fontSize: 10,
              },
            },
          },
        },
      ];
    } else if (idChart == 'chart_IntervencionesDiarias') {
      chartOptions.title.subtext =
        TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('evolucion_diaria');
      chartOptions.media = [
        {
          // titles maxHeight: 310
          query: {
            maxHeight: 310,
          },
          option: {
            title: {
              itemGap: 3,
              textStyle: {
                fontSize: 13,
              },
              subtextStyle: {
                fontSize: 10,
              },
            },
          },
        },
        {
          //barWidth peq
          query: {
            maxWidth: 639,
          },
          option: {
            series: {
              barWidth: 10,
            },
          },
        },
        {
          //barWidth big
          query: {
            minWidth: 640,
          },
          option: {
            series: {
              barWidth: 16,
            },
          },
        },
      ];
    } else {
      chartOptions.title.subtext =
        TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('evolucion_anual');
      chartOptions.media = [
        {
          // titles
          query: {
            maxHeight: 155,
          },
          option: {
            title: {
              itemGap: 3,
              textStyle: {
                fontSize: 13,
              },
              subtextStyle: {
                fontSize: 10,
              },
            },
          },
        },
        {
          //barWidth peq
          query: {
            maxWidth: 639,
          },
          option: {
            series: {
              barWidth: 10,
            },
          },
        },
        {
          //barWidth big
          query: {
            minWidth: 640,
          },
          option: {
            series: {
              barWidth: 16,
            },
          },
        },
      ];
    }

    initChart(idChart, chartOptions);
  }
}

// Stacked bar con dos columnas por categoría.
export function echartIntervencionesTotalesStackedDouble(
  vis,
  datos,
  idChart,
  idNoData,
) {
  let chartOptions = JSON.parse(JSON.stringify(options));
  chartOptions.tooltip.formatter = options.tooltip.formatter;
  chartOptions.yAxis[0].axisLabel.formatter =
    options.yAxis[0].axisLabel.formatter;

  if (datos.resultset.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);

    let seriesMap = {
      0: {},
      1: {},
    };

    const groupedDataPenultimo = {};
    const groupedDataUltimo = {};

    const resultSet = resultsetWithFields(datos);

    // // Agrupar los datos por mes/año
    resultSet.forEach((row) => {
      if (!groupedDataPenultimo[row.tiempo]) {
        groupedDataPenultimo[row.tiempo] = {};
        chartOptions.xAxis[0].data.push(row.tiempo);
      }
      groupedDataPenultimo[row.tiempo][row.category] =
        row.intervenciones_penultimo;

      if (!groupedDataUltimo[row.tiempo]) {
        groupedDataUltimo[row.tiempo] = {};
      }
      groupedDataUltimo[row.tiempo][row.category] = row.intervenciones_ultimo;

      if (!chartOptions.legend.data.includes(row.category)) {
        chartOptions.legend.data.push(row.category);
        seriesMap[0][row.category] = {
          name: row.category,
          type: 'bar',
          stack: 'penultimo',
          barWidth: 10,
          data: [],
          color: COLORS_GENDER.grisClaro,
        };
        seriesMap[1][row.category] = {
          name: row.category,
          type: 'bar',
          stack: 'ultimo',
          barWidth: 10,
          data: [],
        };
        chartOptions.media = [
          {
            // titles
            query: {
              maxHeight: 155,
            },
            option: {
              title: {
                itemGap: 3,
                textStyle: {
                  fontSize: 13,
                },
                subtextStyle: {
                  fontSize: 10,
                },
              },
            },
          },
          {
            //barWidth big
            query: {
              minWidth: 640,
            },
            option: {
              series: [
                {
                  stack: 'penultimo',
                  barWidth: 16,
                },
                {
                  stack: 'ultimo',
                  barWidth: 16,
                },
              ],
            },
          },
        ];
      }
    });

    chartOptions.xAxis[0].data.forEach((time) => {
      chartOptions.legend.data.forEach((cat) => {
        seriesMap[0][cat].data.push(groupedDataPenultimo[time][cat] || 0);
        seriesMap[1][cat].data.push(groupedDataUltimo[time][cat] || 0);
      });
    });
    const transformedSeries = Object.keys(seriesMap).flatMap((key) =>
      Object.values(seriesMap[key]),
    );

    chartOptions.series = transformedSeries;

    chartOptions.tooltip.formatter = (params) => {
      const ultimoMes = Dashboards.getParameterValue('paramUltimoMes');
      const paramUltimoAnio = Dashboards.getParameterValue('paramUltimoAnio');
      const paramPenultimoAnio =
        Dashboards.getParameterValue('paramPenultimoAnio');
      let ultimoAnio;
      let penultimoAnio;

      if (ultimoMes.substring(4, 6) === '01') {
        ultimoAnio = paramPenultimoAnio;
        penultimoAnio = (parseInt(paramPenultimoAnio) - 1).toString();
      } else {
        ultimoAnio = paramUltimoAnio;
        penultimoAnio = paramPenultimoAnio;
      }

      let tooltipContent = '';
      params.forEach((param) => {
        const year =
          param.color === COLORS_GENDER.grisClaro ? penultimoAnio : ultimoAnio;

        tooltipContent += `<div style="width: 100%; justify-content: space-between; text-align: justify; display: block;"><span>${
          param.marker
        } ${year} ${capitalizarTexto(
          param.seriesName,
        )}</span><span style="float:right; margin-left: 20px;">${addPointInteger(
          Math.round(param.value),
        )}</span><br/></div>`;
      });
      return tooltipContent;
    };

    chartOptions.title.subtext =
      TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('evolucion_mensual');
    chartOptions.xAxis[0].axisLabel.formatter = (value) => {
      return MONTHS_YEAR_SHORT[DEFAULT_LANGUAGE].get(
        parseInt(value, 10).toString(),
      );
    };

    initChart(idChart, chartOptions);
  }
}
